module.exports = __webpack_public_path__ + "img/l8.4ec2074b.png";